/** P32 (Feb 27, 2026) — Bottom action bar: Prev / Skip / Delete / Confirm. */
import React from 'react';
import {
  CaretLeft, CaretRight, CheckCircle, SkipForward, Spinner, Trash,
} from '@phosphor-icons/react';
import { Button } from '../../ui/button';

const ReviewActionBar = ({ index, saving, onPrev, onSkip, onDelete, onConfirm }) => (
  <div className="border-t border-slate-200 p-3 flex items-center justify-between gap-2 bg-slate-50">
    <div className="flex items-center gap-1">
      <Button
        size="sm"
        variant="outline"
        onClick={onPrev}
        disabled={index === 0}
        data-testid="review-prev"
        title="Previous (←)"
      >
        <CaretLeft size={14} />
      </Button>
      <Button
        size="sm"
        variant="outline"
        onClick={onSkip}
        data-testid="review-skip"
        title="Skip (Del)"
      >
        <SkipForward size={14} className="mr-1" /> Skip
      </Button>
      <Button
        size="sm"
        variant="ghost"
        onClick={onDelete}
        className="text-red-500 hover:text-red-700"
        data-testid="review-delete"
      >
        <Trash size={14} />
      </Button>
    </div>
    <div className="flex items-center gap-1">
      <Button
        size="sm"
        onClick={onConfirm}
        disabled={saving}
        className="bg-indigo-900 hover:bg-indigo-800 text-white"
        data-testid="review-confirm"
        title="Confirm & Next (Enter)"
      >
        {saving ? <Spinner size={14} className="animate-spin" /> : (
          <>
            <CheckCircle size={14} className="mr-1" /> Confirm
            <CaretRight size={14} className="ml-1" />
          </>
        )}
      </Button>
    </div>
  </div>
);

export default ReviewActionBar;
